<template>
  <div class="visualizer">
    <spinner v-if="loading && dataLen > 0"></spinner>
    <div class="raised-frame bg-white">
      <div class="d-flex justify-content-between bg-background rounded-top">
        <h2 class="px-3 py-1 my-0">{{hebrew ? 'טקסט' : 'Text'}}</h2>
        <router-link class="search-link text-body mb-1 mx-1 my-auto px-1 rounded" to="/">
          {{hebrew ? 'טען טקסט חדש' : 'Reload Text'}}
          <i v-if="hebrew" class="fa fa-arrow-circle-left" aria-hidden="true"></i>
          <i v-else class="fa fa-arrow-circle-right" aria-hidden="true"></i>
        </router-link>
      </div>
      <iframe v-if="!loading && dataLen > 0" id='frame' 
        class="w-100 border-0"
        style="height:65vh"
        :src="currentDT"
      />
      <div class="messages-wrap" v-else>
        <Messages></Messages>
      </div>
    </div>   
  </div>
</template>

<script>
import Spinner from '@/components/spinner'
import Messages from '@/components/Messages'
export default {
  name: 'Visualizer',
  components: { Spinner, Messages },
  data() {
    return {
      loading: true
    }
  },  
  mounted: function() {
  },
  watch: {
    currentDT: function(val) {
      //do something when the data changes.
      if (val) {
          this.loading = false
      }
    },
    dataLen: function(val) {
      if (val) {
          this.loading = true
      }
    },          
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    dataLen: function() {
      return this.$store.state.selectedResults.length;
    },    
    currentDT: function() {
      return '/visualizer/get/'+this.$store.state.visualizerResults+'/sankey.html'
    }
  }
}
</script>  
<style scoped>
.messages-wrap{
  height: calc(100vh - 230px);
}
.raised-frame {
  overflow-y: auto;
}
</style>